import { create } from 'zustand';
import type { Chat } from '@/entities/conversation';

interface PendingOfferState {
  /** The chat an operator was just asked to take over (`new_chat` push). */
  offer: Chat | null;
  setOffer: (offer: Chat | null) => void;
}

/**
 * Ephemeral UI state: the hand-over offer awaiting accept / reject (cpanel's
 * `chat.newChat` Redux field). It is set by the socket from anywhere in the app
 * and rendered by the inbox page — exactly cpanel's behaviour, where the prompt
 * only appeared once the chat page was open. Not server state: the chat itself
 * is refetched through the entity's queries.
 */
export const usePendingOfferStore = create<PendingOfferState>((set) => ({
  offer: null,
  setOffer: (offer) => set({ offer }),
}));
